export interface Administrator {
  readonly id: number
}

export function fromJSON(json: any): Administrator {
  return {
    id: json.id,
  }
}
